import { z } from 'zod';
export const pairingImportBodySchema = z.object({
    taskIds: z.array(z.string().uuid()).default([]),
    taskGroupIds: z.array(z.string().uuid()).default([]),
    familyMemberIds: z.array(z.string().uuid()).default([]),
    pinMessageIds: z.array(z.string().uuid()).default([]),
    familyConsentConfirmed: z.boolean().optional(),
});
//# sourceMappingURL=pairingImport.schema.js.map